import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function AlertDialog(props: {
  message: string;
  title: string;
  type?: "error" | "warning" | "info" | "success";
  show?: boolean;
  handleClose?: () => void;
  handleSubmit?: () => void;
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    if (props.handleClose) props.handleClose();
    setOpen(false);
  };

  const handleSubmit = () => {
    if (props.handleSubmit) props.handleSubmit();
    setOpen(false);
  };

  React.useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <div>
      {/* <Button variant='outlined' onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {props.title ? props.title : ""}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            {props.message ? props.message : ""}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {props.type === "warning" && (
            <Button onClick={handleClose}>Cancel</Button>
          )}
          <Button onClick={handleSubmit} autoFocus>
            {props.type === "warning" ? "Confirm" : "OK"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
